
import { defineComponent } from 'vue';
import { modalsNames } from '@/utils/modals';
import CommonModal from './CommonModal.vue';

export default defineComponent({
  name: 'ModalListOfCountries',
  components: {
    CommonModal,
  },

  setup() {
    const modalName = modalsNames.modalListOfCountries;
    return {
      modalName,
    };
  },
});
